import { Controller } from "@hotwired/stimulus"

// Store product content tabs (TMS-996): the WAI-ARIA tabs pattern — one tab stop, arrow keys
// (and Home/End) move between tabs, and the selected tab's panel is the only one shown.
export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    this.activate(this.tabTargets.indexOf(event.currentTarget))
  }

  keydown(event) {
    const index = this.tabTargets.indexOf(event.currentTarget)
    const last = this.tabTargets.length - 1
    const next = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: last }[event.key]
    if (next === undefined) return

    event.preventDefault()
    const target = next > last ? 0 : next < 0 ? last : next
    this.activate(target)
    this.tabTargets[target].focus()
  }

  activate(index) {
    this.tabTargets.forEach((tab, i) => {
      const selected = i === index
      tab.setAttribute("aria-selected", selected)
      tab.tabIndex = selected ? 0 : -1
      tab.classList.toggle("is-active", selected)
    })
    this.panelTargets.forEach((panel, i) => { panel.hidden = i !== index })
  }
}
